import { ButtonLink, Reveal, SectionLabel } from "@/components/common";
import { DisciplineMap } from "@/components/DisciplineMap";
import { useSite, openResume } from "@/lib/site";
import { useSeo } from "@/lib/seo";
import { TestimonialsBrowser } from "@/components/testimonials/TestimonialsBrowser";

export default function About() {
  const { settings } = useSite();
  useSeo({ title: settings && `About — ${settings.name}`, description: settings?.about?.intersection });
  if (!settings) return null;
  const a = settings.about;
  return (
    <div data-testid="about-page" className="pt-[72px]">
      <section className="container-x pb-20 pt-16 md:pt-24">
        <SectionLabel number="—">About</SectionLabel>
        <h1 className="mt-6 max-w-5xl font-display text-5xl leading-[0.95] sm:text-6xl lg:text-8xl">{a.heading}</h1>
        <p className="mt-10 max-w-2xl text-lg leading-relaxed text-silver md:text-xl">{a.intro}</p>
      </section>

      <section className="inverse py-24 md:py-32" data-testid="about-intersection">
        <div className="container-x grid gap-16 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-6">
            <SectionLabel number="01">The intersection</SectionLabel>
            <blockquote className="mt-8 font-display text-3xl leading-[1.15] md:text-[2.6rem]">
              <span className="text-gold">“</span>{a.intersection}<span className="text-gold">”</span>
            </blockquote>
          </div>
          <div className="lg:col-span-6">
            <DisciplineMap disciplines={a.disciplines} />
          </div>
        </div>
      </section>

      <section className="container-x grid gap-12 py-24 md:grid-cols-12 md:py-32">
        <div className="md:col-span-4"><SectionLabel number="02">How I work</SectionLabel></div>
        <div className="space-y-8 md:col-span-7">
          {a.body.map((p, i) => (
            <Reveal key={i} delay={i * 0.05}><p className={i === 0 ? "font-display text-2xl leading-snug md:text-3xl" : "text-base leading-relaxed text-fg/85 md:text-lg"}>{p}</p></Reveal>
          ))}
        </div>
      </section>

      <section className="container-x pb-24 md:pb-32">
        <SectionLabel number="03">Principles</SectionLabel>
        <ul className="mt-10 grid gap-px overflow-hidden rounded-md border border-line/10 bg-line/10 md:grid-cols-2">
          {a.principles.map((p, i) => (
            <li key={p.title} className="bg-canvas p-8 md:p-12" data-testid={`principle-${i}`}>
              <span className="font-mono text-xs text-gold">P.{String(i + 1).padStart(2, "0")}</span>
              <p className="mt-4 font-display text-3xl">{p.title}</p>
              <p className="mt-3 text-silver">{p.description}</p>
            </li>
          ))}
        </ul>
        <div className="mt-16 flex flex-wrap gap-3">
          <ButtonLink to="/work" testId="about-view-work">View My Work</ButtonLink>
          <ButtonLink to="/contact?type=employment" variant="secondary" testId="about-hire-me">Hire Me</ButtonLink>
          <ButtonLink onClick={() => openResume(settings)} variant="gold" testId="about-download-resume">Download Résumé</ButtonLink>
        </div>
      </section>

      <TestimonialsBrowser number="04" />
    </div>
  );
}
